import subDays from "date-fns/subDays";
import DistributorIcon from "../svgs/map_region.svg";
import CalenderIcon from "../svgs/event_calendar.svg";
import BkashIcon from "../svgs/bkash.svg";
import BangladeshIcon from "../svgs/Region.svg";
import AreaIcon from "../svgs/area.svg";
import TerritoryIcon from "../svgs/territory.svg";
import PhoneIcon from "../svgs/phone.svg";
import { MANAGER_TYPES, USER_TYPES } from "../../UserList/utils/userConfigs";
const get_years = () => {
  var getCurrentYear = new Date().getFullYear();
  var listOfYears = Array.from({ length: 6 }, (_, i) => ({
    name: getCurrentYear - i,
    id: getCurrentYear - i,
  }));

  return listOfYears;
};
const report_types = [
  { id: "cluster_wise", name: "Circle wise" },
  { id: "region_wise", name: "Zone wise" },
  { id: "area_wise", name: "Area wise" },
  { id: "territory_wise", name: "Territory wise" },
  { id: "agency_wise", name: "Agency wise" },
  { id: "ff_wise", name: "Field-force wise" },
  { id: "merchant_wise", name: "Merchant wise" },
];

const referral_campaign_report_types = [
  { id: "call_wise", name: "Call wise" },
  // { id: "employee_wise", name: "Employee wise" },
  { id: "merchant_wise", name: "Merchant wise" },
];

const dump_report_types = [
  { id: "account", name: "Account" },
  { id: "approval", name: "Approval" },
  { id: "repayment", name: "Repayment" },
];

const non_transacting_report_types = [
  { id: "merchant_wise", name: "Merchant wise" },
];

const attendance_summary_report_types = [
  { id: "cluster_wise", name: "Circle wise" },
  { id: "region_wise", name: "Zone wise" },
  { id: "area_wise", name: "Area wise" },
  { id: "territory_wise", name: "Territory wise" },
  { id: "agency_wise", name: "Distributor wise" },
  { id: "ff_wise", name: "Employee wise" },
];

const report_types_route_target_vs_achivement = [
  { id: "ff_wise", name: "Field-force wise" },
  { id: "route_wise", name: "Route wise" },
];

const acquisition_report_types = [
  { id: "detail-acquisition-report", name: "Merchant wise" },
  { id: "cluster-wise-acquisition-report", name: "Circle wise" },
  { id: "circle-wise-acquisition-report", name: "Zone wise" },
  { id: "zone-wise-acquisition-report", name: "Area wise" },
  { id: "territory-wise-acquisition-report", name: "Territory wise" },
  { id: "distributor-wise-acquisition-report", name: "Distributor wise" },

  // { id: "serving-emp-wise-acquisition-report", name: "Serving employee wise" },
  {
    id: "acquiring-emp-wise-acquisition-report",
    name: "Acquiring employee wise",
  },
];
const filter_whitelist_attendance_summary = {
  "": ["attendance_summary_report_type"],
  cluster_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
  ],
  region_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
    "region",
  ],
  area_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
    "region",
    "area",
  ],
  territory_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
    "region",
    "area",
    "territory",
  ],
  agency_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
    "region",
    "area",
    "agency",
    "territory",
  ],
  ff_wise: [
    "attendance_summary_report_type",
    "employee_type",
    "attendance_date",
    "cluster",
    "region",
    "area",
    "agency",
    "territory",
    "field_force",
  ],
};

const filter_whitelist_detailed_acquisition = {
  "": ["acquisition_report_type", "start_time", "end_time"],

  "detail-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",
  ],
  "cluster-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
  ],
  "circle-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
  ],
  "zone-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
  ],
  "territory-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
  ],
  "distributor-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
  ],
  "serving-emp-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
  ],
  "acquiring-emp-wise-acquisition-report": [
    "acquisition_report_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",
  ],
};

const filter_whitelist_assisted_ekyc = {
  "": ["filter_type"],
  geo: [
    "filter_type",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
  ],
  emp: [
    "filter_type",
    "start_time",
    "end_time",
    "employee_whitelisting_number",
  ],
  lead: ["filter_type", "merchant_lead_number"],
};

const filter_whitelist_detailed_assisted_ekyc = {
  "": ["filter_type"],
  geo: [
    "filter_type",
    "app_status_category",
    "app_status_sub_category",
    "start_time",
    "end_time",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
  ],
  emp: [
    "filter_type",
    "app_status_category",
    "app_status_sub_category",
    "start_time",
    "end_time",
    "employee_whitelisting_number",
  ],
  lead: ["filter_type", "merchant_lead_number"],
};

const months = [
  {
    name: "January",
    id: "01",
  },
  {
    id: "02",
    name: "February",
  },
  {
    id: "03",
    name: "March",
  },
  {
    id: "04",
    name: "April",
  },
  {
    id: "05",
    name: "May",
  },
  {
    id: "06",
    name: "June",
  },
  {
    id: "07",
    name: "July",
  },
  {
    id: "08",
    name: "August",
  },
  {
    id: "09",
    name: "September",
  },
  {
    id: "10",
    name: "October",
  },
  {
    id: "11",
    name: "November",
  },
  {
    id: "12",
    name: "December",
  },
];
const get_months = (last_number_of_month) => {
  var today = new Date();
  var d;
  var lastMonthList = [];
  var months = [...Array(12).keys()].map((key) => ({
    id: String(key + 1).padStart(2, "0"),
    name: new Date(0, key).toLocaleString("en", { month: "long" }),
  }));
  for (var i = last_number_of_month - 1; i >= 0; i -= 1) {
    d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    lastMonthList.push(months[d.getMonth()]);
  }
  return lastMonthList.reverse();
};

const report_tabs = [
  {
    name: "merchant_performance",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, // group 1
  {
    name: "acquisition_performance",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, // group 2
  {
    name: "visit_performance",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  }, //... 3
  {
    name: "attendance",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, //...4
  {
    name: "mapping",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, //...5
  {
    name: "dump_files",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  }, //...6
  {
    name: "categorization",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  }, //...7
  {
    name: "target_vs_achievement",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
  {
    name: "payment_speaker",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.WAREHOUSE_MANAGER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, //...8
  {
    name: "campaign",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, //...9
  {
    name: "discontinued",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  }, //...10
  {
    name: "bank_inclusion",
    userTypes: [USER_TYPES.CS_SUPER_USER],
  }, //...11
  {
    name: "merchant_loan",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
  }, //...12
  {
    name: "all",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
  },
];

const filtered_report_tabs_for_user_type = {
  warehouse_manager: ["payment_speaker"],
  cs_super_user: ["bank_inclusion"],
};

// const filtered_report_tabs_for_user_type = {
//   "bkash-super-user": [
//     "merchant_performance",
//     "acquisition_performance",
//     "visit_performance",
//     "attendance",
//     "mapping",
//     "dump_files",
//     "categorization",
//     "target_vs_achievement",
//     "payment_speaker",
//     "campaign",
//     "discontinued",
//     "bank_inclusion",
//     "merchant_loan",
//     "all",
//   ],
//   cluster_head: [
//     "merchant_performance",
//     "acquisition_performance",
//     "visit_performance",
//     "payment_speaker",
//     "campaign",
//   ],
//   area_manager: [
//     "merchant_performance",
//     "acquisition_performance",
//     "visit_performance",
//     "payment_speaker",
//     "campaign",
//   ],
//   regional_manager: [
//     "merchant_performance",
//     "acquisition_performance",
//     "visit_performance",
//     "payment_speaker",
//     "campaign",
//   ],
//   territory_manager: [
//     "merchant_performance",
//     "acquisition_performance",
//     "visit_performance",
//     "payment_speaker",
//     "campaign",
//   ],
//   agency_user: [
//     "merchant_performance",
//     "acquisition_performance",
//     "payment_speaker",
//     "campaign",
//   ],
//   warehouse_manager: ["payment_speaker"],
//   cs_super_user: ["bank_inclusion"],
// };

const filter_whitelist = [
  "year",
  "month",
  "report_type",
  "report_type_route_target_vs_achivement",
  "business_unit",
  "sub_unit",
  "transaction_date",
  "cluster",
  "regions",
  "areas",
  "territories",
  "agency",
  "field_force",
  "reg_start_date",
  "reg_end_date",
  "status",
];
const merchant_status = [
  { id: "ACTIVE", name: "Active" },
  { id: "INACTIVE", name: "Inactive" },
  { id: "DISCONTINUED", name: "Discontinued" },
  { id: "RECYCLED", name: "Recycled" },
  { id: "CLOSED", name: "Closed" },
];

const non_transacting_merchant_status = [
  { id: "ACTIVE", name: "Active" },
  { id: "INACTIVE", name: "Inactive" },
  //{ id: "DISCONTINUED", name: "Discontinued" },
];

const employee_types = [
  { id: "MAO", name: "MAO" },
  { id: "MMO", name: "MMO" },
  { id: "MDO", name: "MDO" },
];
const employee_types_attendance = [
  { id: "field_force", name: "Field force" },
  // { id: "supervisor", name: "Supervisor" },
  // { id: "operations_manager", name: "Operations manager" },
  // { id: "territory_manager", name: "Territory manager" },
]; //field_force,territory_manager,supervisor,operations_manager

const filter_types_assisted_ekyc = [
  { name: "Geography", id: "geo" },
  { name: "Employee", id: "emp" },
  { name: "Lead", id: "lead" },
];

const referral_status_types = [
  { name: "Successful", id: "successful" },
  { name: "Failed", id: "failed" },
  { name: "In Progress", id: "in_progress" },
  { name: "Merchant Denied", id: "merchant_denied" },
  { name: "Organic", id: "organic" },
];

const app_status_categories = [
  {
    name: "Initiation Status",
    id: "initiation",
  },
  {
    name: "Machine QC Status",
    id: "mqc",
  },
  {
    name: "Human QC Status",
    id: "hqc",
  },
  {
    name: "Wallet Status",
    id: "incoming_open",
  },
];
//Full, Mixed, EMI
const pricing_options_options = [
  { id: "Full", name: "Full" },
  { id: "Mixed", name: "Mixed" },
  { id: "EMI", name: "EMI" },
];
//Binded, Not Binded
const binding_status_options = [
  { id: "Binded", name: "Binded" },
  { id: "Not Binded", name: "Not Binded" },
];
//Device Return, Device Receive, Device Bind, Device Un-Bind
const action_type_options = [
  { id: "Device Return", name: "Device Return" },
  { id: "Device Receive", name: "Device Receive" },
  { id: "Device Bind", name: "Device Bind" },
  { id: "Device Un-Bind", name: "Device Un-Bind" },
];
//route_wise, employee_wise, distributor_wise, region_wise, area_wise, zone_wise, agency_wise
const call_quality_report_types = [
  { name: "Detailed", id: "detailed" },
  { name: "Field-force wise", id: "employee_wise" },
  { id: "cluster_wise", name: "Circle wise" },
  { id: "region_wise", name: "Zone wise" },
  { id: "area_wise", name: "Area wise" },
  { id: "territory_wise", name: "Territory wise" },
  { id: "agency_wise", name: "Distributor wise" },
];

const outlet_status_types = [
  { name: "Open", id: "open" },
  { name: "Close", id: "close" },
  { name: "Not Found", id: "not_found" },
];
const call_types = [
  { name: "Regular", id: "regular" },
  { name: "Ad-hoc", id: "adhoc" },
];
const qr_validation_types = [
  { name: "Matched", id: "matched" },
  { name: "Mismatched", id: "mismatched" },
  { name: "Invalid", id: "invalid" },
  { name: "Not-found", id: "not_found" },
];

//<3 mins, 3-5 mins, 5-10 mins, >10 mins - LIST
const call_duration_tag_types = [
  { name: "<3 mins", id: "<3 mins" },
  { name: "3-5 mins", id: "3-5 mins" },
  { name: "5-10 mins", id: "5-10 mins" },
  { name: ">10 mins", id: ">10 mins" },
];
//<30 m, 30-50 m, 50-100 m, 100-250 m,>250m - LIST
const distance_tag_types = [
  { name: "Detailed", id: "<30 m" },
  { name: "30-50 m", id: "30-50 md" },
  { name: "50-100 m", id: "50-100 m" },
  { name: "100-250 m", id: "100-250 m" },
  { name: ">250m", id: ">250m" },
];

const request_types = [
  { name: "New", id: "new" },
  { name: "Resubmitted", id: "resubmitted" },
];

const l1_action_types = [
  { name: "L1 Approved", id: "l1_approved" },
  { name: "L1 Rejected", id: "l1_rejected" },
  { name: "L1 Edited and Approved", id: "l1_edited_and_approved" },
];

const l2_action_types = [
  { name: "L2 Approved", id: "l2_approved" },
  { name: "L2 Rejected", id: "l2_rejected" },
  { name: "Sent Back to L1", id: "sent_back_to_l1" },
];

const action_types = [
  { name: "L1 Approved", id: "l1_approved" },
  { name: "L1 Rejected", id: "l1_rejected" },
  { name: "L1 Edited and Approved", id: "l1_edited_and_approved" },
  { name: "Sent Back to QC L1", id: "sent_back_to_qc_l1" },
  { name: "L2 Approved", id: "l2_approved" },
  { name: "L2 Rejected", id: "l2_rejected" },
  { name: "Requested", id: "requested" },
];

const app_status_sub_categories = {
  hqc: [
    { name: "Rejected", id: "rejected" },
    { name: "Approved", id: "approved" },
    { name: "Forcefully Rejected", id: "force_rejected" },
    { name: "Escalated", id: "escalated" },
  ],
  mqc: [
    { name: "Failed", id: "failed" },
    { name: "Pass/Tolerance", id: "pass/tolerance" },
  ],
  initiation: [
    //{ name: "Limited", id: "limited" },
    //{ name: "Full", id: "full" },
    { name: "Initialized", id: "initialized" },
    { name: "Submitted", id: "submitted" },
    { name: "Re-Submitted", id: "resubmitted" },
  ],
  incoming_open: [
    { name: "Half Wallet Open", id: "incoming_open" },
    { nme: "Full Wallet Open", id: "full_wallet_open" },
  ],
};

const filter_config_ordered_keys = [
  "year",
  "month",
  "date",
  "report_type",
  "binding_status",
  "pricing_options",
  "attendance_summary_report_type",
  "report_type_route_target_vs_achivement",
  "non_transacting_report_type",
  "referral_campaign_report_type",
  "dump_report_type",
  "campaign_name",
  "employee_type",
  "action_type",
  "quiz_id",
  "business_unit",
  "sub_unit",
  "acquisition_report_type",
  "transaction_date",
  "cluster",
  "region",
  "area",
  "territory",
  "agency",
  "field_force",
  "attendance_date",
  "reg_start_date",
  "reg_end_date",
  "start_date",
  "end_date",
  "binding_start_date",
  "binding_end_date",
  "action_start_date",
  "action_end_date",
  "start_time",
  "end_time",
  "call_start_date",
  "call_end_date",
  "status",
  "non_transacting_status",
  "filter_type",
  "employee_whitelisting_number",
  "merchant_lead_number",
  "app_status_category",
  "app_status_sub_category",
  "call_quality_report_type",
  "assigned_call_start_date",
  "assigned_call_end_date",
  "merchant_registration_start_date",
  "merchant_registration_end_date",
  "outlet_status",
  "referral_status",
  "call_type",
  "qr_validation",
  "call_duration_tag",
  "distance_tag",
  "request_types",
  "l1_action_types",
  "l2_action_types",
  "action_types",
];
const filter_config = {
  year: {
    label: "Year",
    key: "year",
    options: get_years(),
    value: "",
    category: "date_filter",
    icon: CalenderIcon,
  },
  month: {
    label: "Month",
    key: "month",
    options: get_months(6),
    value: "",
    category: "date_filter",
    icon: CalenderIcon,
  },
  date: {
    label: "Date",
    key: "date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: subDays(new Date(), 1),
    category: "date_filter",
    icon: CalenderIcon,
  },
  report_type: {
    label: "Report type",
    key: "report_type",
    options: report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  referral_campaign_report_type: {
    label: "Report type",
    key: "referral_campaign_report_type",
    options: referral_campaign_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  dump_report_type: {
    label: "Report Type",
    key: "dump_report_type",
    options: dump_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  campaign_name: {
    label: "Campaign Name",
    key: "campaign_name",
    options: [],
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  //call_quality_report_type
  call_quality_report_type: {
    label: "Report type",
    key: "call_quality_report_type",
    options: call_quality_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  outlet_status: {
    label: "Outlet Status",
    key: "outlet_status",
    options: outlet_status_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  referral_status: {
    label: "Referral Status",
    key: "referral_status",
    options: referral_status_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  call_type: {
    label: "Call Type",
    key: "call_type",
    options: call_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  qr_validation: {
    label: "QR Validation",
    key: "qr_validation",
    options: qr_validation_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  call_duration_tag: {
    label: "Call Duration Tag",
    key: "call_duation_tag",
    options: call_duration_tag_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  distance_tag: {
    label: "Distance Tag",
    key: "distance_tag",
    options: distance_tag_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  request_types: {
    label: "Request Types",
    key: "request_types",
    options: request_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  l1_action_types: {
    label: "L1 Action Types",
    key: "l1_action_types",
    options: l1_action_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  l2_action_types: {
    label: "L2 Action Types",
    key: "l2_action_types",
    options: l2_action_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  action_types: {
    label: "Action Types",
    key: "action_types",
    options: action_types,
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
    type: "multi-select",
  },
  // route: {
  //   label: "Route",
  //   key: "route",
  //   options: [],
  //   value: "",
  //   category: "entity_filter",
  //   icon: DistributorIcon,
  // },
  pricing_options: {
    label: "Pricing options",
    key: "pricing_options",
    options: pricing_options_options,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  binding_status: {
    label: "Binding status",
    key: "binding_status",
    options: binding_status_options,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  action_type: {
    label: "Action type",
    key: "action_type",
    options: action_type_options,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  attendance_summary_report_type: {
    label: "Report type",
    key: "attendance_summary_report_type",
    options: attendance_summary_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  non_transacting_report_type: {
    label: "Report type",
    key: "non_transacting_report_type",
    options: non_transacting_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  filter_type: {
    label: "Filter type",
    key: "filter_type",
    options: filter_types_assisted_ekyc,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  report_type_route_target_vs_achivement: {
    label: "Report type",
    key: "report_type_route_target_vs_achivement",
    options: report_types_route_target_vs_achivement,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  quiz_id: {
    label: "Quiz ID",
    key: "quiz_id",
    options: [],
    value: "",
    category: "category_filter",
  },
  business_unit: {
    label: "Business unit",
    key: "business_unit",
    options: [],
    paramTag: "business_unit",
    type: "multi-select",
    value: [],
    category: "category_filter",
  },

  sub_unit: {
    label: "Business sub-unit",
    key: "sub_unit",
    options: [],
    paramTag: "sub_unit",
    type: "multi-select",
    value: [],
    category: "category_filter",
  },
  acquisition_report_type: {
    label: "Report type",
    key: "acquisition_report_type",
    options: acquisition_report_types,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
  },
  app_status_category: {
    label: "App status",
    key: "app_status_category",
    options: app_status_categories,
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
    childKey: "app_status_sub_category",
    dependant: "app_status_sub_category",
  },
  app_status_sub_category: {
    label: "App sub-status",
    key: "app_status_sub_category",
    options: [],
    value: "",
    category: "type_filter",
    icon: DistributorIcon,
    parentDependant: "app_status_category",
  },
  transaction_date: {
    label: "Transaction date",
    key: "transaction_date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },
  cluster: {
    label: "Circle",
    key: "cluster",
    options: [],
    paramTag: "cluster",
    childKey: "region",
    childApiPoint: "organizations/api/v1/regions",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: BangladeshIcon,
  },
  region: {
    label: "Zone",
    key: "region",
    options: [],
    paramTag: "region",
    childKey: "area",
    childApiPoint: "organizations/api/v1/areas",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: BangladeshIcon,
  },
  area: {
    label: "Area",
    key: "area",
    options: [],
    //disabledLabel: "Select an region first",
    paramTag: "area",
    childKey: "territory",
    childApiPoint: "organizations/api/v1/territories",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: AreaIcon,
  },
  territory: {
    label: "Territory",
    key: "territory",
    options: [],
    // disabledLabel: "Select an area first",
    paramTag: "territory",
    childKey: "agency",
    childApiPoint: "organizations/api/v1/agency",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: TerritoryIcon,
  },
  agency: {
    label: "Distributor",
    key: "agency",
    options: [],
    //disabledLabel: "Select an territory first",
    childKey: "field_force",
    childApiPoint: "admin_panel/v1/mdo-list",
    paramTag: "agency",
    type: "multi-select",
    value: [],
    category: "geo_filter",
    icon: DistributorIcon,
  },

  field_force: {
    label: "Field-force",
    key: "field_force",
    options: [],
    category: "entity_filter",

    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
    icon: DistributorIcon,
  },

  team: {
    label: "Employee type",
    key: "team",
    options: employee_types,
    category: "entity_filter",

    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
    icon: DistributorIcon,
  },
  employee_type: {
    label: "Employee type",
    key: "employee_type",
    options: employee_types_attendance,
    category: "type_filter",
    value: "",
    icon: DistributorIcon,
  },
  attendance_date: {
    label: "Attendance date",
    key: "attendance_date",
    value: "",
    type: "date-picker",
    maxDate: new Date(),
    category: "date_filter",
    icon: CalenderIcon,
  },

  reg_start_date: {
    label: "Registration start date",
    key: "reg_start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "reg_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  reg_end_date: {
    label: "Registration end date",
    key: "reg_end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "reg_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  start_date: {
    label: "Start date",
    key: "start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  end_date: {
    label: "End date",
    key: "end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  assigned_call_start_date: {
    label: "Call Start Date",
    key: "assigned_call_start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "assigned_call_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  assigned_call_end_date: {
    label: "Call End date",
    key: "assigned_call_end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "assigned_call_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  merchant_registration_start_date: {
    label: "Registration Start Date",
    key: "merchant_registration_start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "merchant_registration_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  merchant_registration_end_date: {
    label: "Registration End Date",
    key: "merchant_registration_end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "merchant_registration_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  binding_start_date: {
    label: "Binding start date",
    key: "binding_start_date",
    value: "",
    type: "date-picker",
    maxDate: new Date(),
    pairedWithEnd: "binding_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  binding_end_date: {
    label: "Binding end date",
    key: "binding_end_date",
    value: "",
    type: "date-picker",
    maxDate: new Date(),
    pairedWithStart: "binding_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  action_start_date: {
    label: "Action start date",
    key: "action_start_date",
    value: "",
    type: "date-picker",
    maxDate: new Date(),
    pairedWithEnd: "action_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  action_end_date: {
    label: "Action end date",
    key: "action_end_date",
    value: "",
    type: "date-picker",
    maxDate: new Date(),
    pairedWithStart: "action_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  start_time: {
    label: "Start date",
    key: "start_time",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "end_time",
    category: "date_filter",
    icon: CalenderIcon,
  },
  end_time: {
    label: "End date",
    key: "end_time",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "start_time",
    category: "date_filter",
    icon: CalenderIcon,
  },
  call_start_date: {
    label: "Call Start date",
    key: "call_start_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithEnd: "call_end_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  call_end_date: {
    label: "Call End date",
    key: "call_end_date",

    value: "",
    type: "date-picker",

    maxDate: new Date(),
    pairedWithStart: "call_start_date",
    category: "date_filter",
    icon: CalenderIcon,
  },
  status: {
    label: "Merchant status",
    key: "status",
    options: merchant_status,
    type: "multi-select",
    //disabledLabel: "Select an territory first",
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
  },
  non_transacting_status: {
    label: "Merchant status",
    key: "non_transacting_status",
    options: non_transacting_merchant_status,
    type: "multi-select",
    //disabledLabel: "Select an territory first",
    value: [],
    category: "type_filter",
    icon: DistributorIcon,
  },
  employee_whitelisting_number: {
    label: "Whitelisting number",
    key: "employee_whitelisting_number",
    type: "text-field",
    value: "",
    category: "geo_filter",
    icon: BkashIcon,
  },

  merchant_lead_number: {
    label: "Lead number",
    key: "merchant_lead_number",
    type: "text-field",

    value: "",
    category: "geo_filter",
    icon: PhoneIcon,
  },
};

const categorization_filter_whitelist = [
  "reg_start_date",
  "reg_end_date",
  "business_unit",
  "sub_unit",
  "regions",
  "areas",
  "status",
];

const filter_whitelist_call_quality = {
  "": ["call_quality_report_type"],
  detailed: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",
    "merchant_registration_start_date",
    "merchant_registration_end_date",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  employee_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  cluster_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  region_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  area_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "area",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  territory_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "area",
    "territory",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
  agency_wise: [
    "call_quality_report_type",
    "assigned_call_start_date",
    "assigned_call_end_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "outlet_status",
    "call_type",
    "qr_validation",
    "call_duration_tag",
    "distance_tag",
  ],
};

const filter_whitelist_merchant = {
  "": [
    "report_type",
    "transaction_date",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  cluster_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  region_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  area_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",
    "area",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  territory_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",
    "area",
    "territory",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  agency_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  ff_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
  merchant_wise: [
    "report_type",
    "transaction_date",
    "cluster",
    "region",
    "area",
    "territory",
    "agency",
    "field_force",

    "reg_start_date",
    "reg_end_date",
    "status",
  ],
};

export {
  filter_config,
  filter_whitelist,
  report_tabs,
  filtered_report_tabs_for_user_type,
  filter_config_ordered_keys,
  filter_whitelist_merchant,
  filter_whitelist_detailed_acquisition,
  filter_whitelist_assisted_ekyc,
  filter_whitelist_detailed_assisted_ekyc,
  filter_whitelist_attendance_summary,
  app_status_sub_categories,
  filter_whitelist_call_quality,
  dump_report_types,
};
